import { EngineeringOutlined } from "@mui/icons-material";

const workExperienceResource = {
    title: "Work Experience",
    singular: "Work Experience",

    collectionField: "workExperiences",

    displayField: "employerName",
    icon: EngineeringOutlined,

    columns: [
        {
            field: "employerName",
            header: "Employer Name",
            type: "text"
        },
        {
            field: "position",
            header: "Position",
            type: "text"
        },
        {
            field: "status",
            header: "Status",
            type: "text"
        },
        {
            field: "endDate",
            header: "End Date",
            type: "date"
        }
    ],

    fields: {
        employerName: {
            name: "employerName",
            label: "Employer Name",
            type: "text",
            required: true
        },
        endDate: {
            name: "endDate",
            label: "End Date",
            type: "date"
        },
        position: {
            name: "position",
            label: "Position",
            type: "text"
        },
        status: {
            name: "status",
            label: "Status",
            type: "text"
        },
        payRate: {
            name: "payRate",
            label: "Pay Rate",
            type: "number"
        },
        isGoverment: {
            name: "isGoverment",
            label: "Is Government",
            type: "checkbox"
        }
    }
};

export default workExperienceResource;
